var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav-dropdown-item"},[_vm._v(" "+_vm._s(_vm.item.title)+" "),_c('div',{staticClass:"vocaline",style:({ background: _vm.backgroundLine })})])
}
var staticRenderFns = []

export { render, staticRenderFns }